import { useState, useEffect } from "react";

const useScreenOrientation = () => {
  const [height, setHeight] = useState<number>(typeof window !== "undefined" ? window.innerHeight : 0);
  const [horizontal, setHorizontal] = useState<boolean>(window.innerWidth > window.innerHeight);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleResize = () => {
      setHeight(window.innerHeight);
      setHorizontal(window.innerWidth > window.innerHeight);
    };

    const handleOrientationChange = () => {
      setTimeout(() => {
        setHeight(window.innerHeight);
        setHorizontal(window.innerWidth > window.innerHeight);
      }, 100);
    };

    setHeight(window.innerHeight);
    setHorizontal(window.innerWidth > window.innerHeight);

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleOrientationChange);
    // iOS Safari / Android Chrome: window "resize" does not always fire when the
    // browser toolbar collapses/expands, but visualViewport "resize" does. This
    // keeps the feed height in sync with the actually visible viewport.
    window.visualViewport?.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleOrientationChange);
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, []);

  return { height, horizontal };
};

export default useScreenOrientation;
